import React from 'react';
import './News.css';
import Swapers from '../../Carousel/Swapers/Swapers';
import Shimmer from '../../Shimmer/Shimmer';
import { imgURL } from '../../Config';

const News = ({ newsData }) => {
   if (!newsData) {
    return <Shimmer />;
  }

  // loaded but no news → render nothing
  if (newsData.length === 0) {
    return null;
  }

  const sortedNews = [...newsData].sort(
    (a, b) => new Date(b?.created_at).getTime() - new Date(a?.created_at).getTime()
  );

  const swiperParams = {
    slidesPerView: 2,
    spaceBetween: 30,
    loop: true,
    autoplay: { delay: 3000, disableOnInteraction: false },
    breakpoints: {
      0: { slidesPerView: 1 },
      768: { slidesPerView: (newsData?.length > 1 ? 1 : newsData?.length) },
      992: { slidesPerView: (newsData?.length > 1 ? 1 : newsData?.length) },
      1200: { slidesPerView: (newsData?.length > 1 ? 1 : newsData?.length) },
      1400: { slidesPerView: (newsData?.length > 1 ? 1 : newsData?.length) },
    },
    equalizeHeights: true,
    slidesData: sortedNews,
    renderSlide: (news) => (
      <div
        className="feature-four__item wow fadeInUp"
        data-wow-duration="1500ms"
        data-wow-delay="100ms"
      >
        <div className="news-card d-flex">
          {/* Image */}
          <div className="news-card-image">
            <img
              src={`${imgURL}news_image/${news.image_path}`}
              alt={news.title}
              className="rounded"
            />
          </div>

          {/* Content */}
          <div className="news-card-content">
            <h6 className="feature-four__item__title">{news.title}{news?.pdf_path && (
              <button
                className="btn btn-sm btn-primary mt-2 p-2 ms-3"
                onClick={() =>
                  window.open(`${imgURL}news_pdf/${news?.pdf_path}`, '_blank')
                }
              >
                Read More
              </button>
            )}</h6>
          </div>
        </div>
      </div>
    ),
  };

  return (
    <section className="feature-four">
      <div className="container">
        <Swapers
          {...swiperParams}
          className="feature-four__carousel acwadam-owl__carousel"
        />
      </div>
    </section>
  );
};

export default News;
